// @flow
import _debug from 'debug';
import { makeActionCreator, reduce } from '../helpers/utils';
import type { Pagination, BookingMade as Booking } from '../types';
import type { State as GlobalState } from './reducer';

const debug = _debug('jp:reducers:bookingsMade');

export const LOAD_BOOKINGS_MADE = 'bookingsReceived/LOAD_BOOKINGS_MADE';
export const LOAD_BOOKINGS_MADE_SUCCESS =
  'bookingsReceived/LOAD_BOOKINGS_MADE_SUCCESS';
export const LOAD_BOOKINGS_MADE_FAIL =
  'bookingsReceived/LOAD_BOOKINGS_MADE_FAIL';
export const SET_FILTER = 'bookingsReceived/SET_FILTER';

export type BookingFilter = 'active' | 'upcoming' | 'past';

export type State = {|
  isLoading: boolean,
  bookings: Array<Booking>,
  filter: BookingFilter,
  error: ?string,
  pagination: Pagination
|};

const initialPagination = {
  count: null,
  currentPage: null,
  perPage: null,
  total: null,
  totalPages: null
};

export const initialState: State = {
  isLoading: true,
  filter: 'past',
  bookings: [],
  error: '',
  pagination: initialPagination
};

export default reduce<State, any>(initialState, {
  [LOAD_BOOKINGS_MADE](state: State, action): State {
    debug(LOAD_BOOKINGS_MADE, action);

    return {
      ...state,
      pagination: initialPagination,
      isLoading: true,
      bookings: []
    };
  },
  [LOAD_BOOKINGS_MADE_SUCCESS](state: State, action): State {
    debug(LOAD_BOOKINGS_MADE_SUCCESS, action);

    if (action && action.payload) {
      const { data: bookings, meta } = action.payload;
      const { pagination } = meta;

      return {
        ...state,
        bookings,
        pagination,
        error: '',
        isLoading: false
      };
    }

    throw new Error('No payload in get bookings made success');
  },
  [LOAD_BOOKINGS_MADE_FAIL](state: State, action): State {
    debug(LOAD_BOOKINGS_MADE_FAIL, action);

    return {
      ...state,
      error:
        action?.error?.message || 'There has been error loading your bookings.',
      bookings: [],
      isLoading: false
    };
  },
  [SET_FILTER](state: State, action): State {
    debug(SET_FILTER, action);

    return {
      ...state,
      filter: action.payload
    };
  }
});

export const setFilter = makeActionCreator(SET_FILTER, 'payload');

export function loadBookingsMade(pageNumber: ?string) {
  return (dispatch: (*) => Promise<*>, getState: () => GlobalState) => {
    const { filter } = getState().bookingsMade;

    const statuses = filter === 'past' ? ['past', 'cancelled'] : [filter];

    return dispatch({
      types: [
        LOAD_BOOKINGS_MADE,
        LOAD_BOOKINGS_MADE_SUCCESS,
        LOAD_BOOKINGS_MADE_FAIL
      ],
      promise: client => client.bookings.getBookingsMade(pageNumber, statuses)
    });
  };
}
